// =========================================
// 全局配置
// =========================================
const CAPTCHA_CONFIG = {
  appId: '196133251',
  type: 'popup',
  userLanguage: 'zh-cn'
};

// =========================================
// 容灾票据生成（官方标准）
// =========================================
function generateDisasterTicket(errorCode = 1001, message = 'js_load_error') {
  const timestamp = Math.floor(Date.now() / 1000);
  const ticket = `trerror_${errorCode}_${CAPTCHA_CONFIG.appId}_${timestamp}`;
  const randstr = '@' + Math.random().toString(36).slice(2);
  return {
    ret: 0,
    ticket,
    randstr,
    errorCode,
    errorMessage: message,
    isDisaster: true
  };
}

function createCaptcha(lang) {
  // 1. 先创建实例占位
  let captchaInstance = null;

  // 2. 创建 Promise
  const promise = new Promise((resolve, reject) => {
    try {
      // 3. 创建验证码
      captchaInstance = new TencentCaptcha(
        CAPTCHA_CONFIG.appId,
        res => {
          // 把实例绑在结果上
          res.captcha = captchaInstance;

          // 验证失败
          if (res.ret === 1) {
            reject({
              type: 'VERIFY_FAILED',
              message: '图形验证失败',
              captcha: captchaInstance
            });
            return;
          }

          // 用户关闭
          if (res.ret === 2) {
            reject({
              type: 'USER_CLOSE',
              message: '用户关闭验证',
              captcha: captchaInstance
            });
            return;
          }

          // 成功 / 容灾
          if (res.ret === 0) {
            resolve({
              ...res,
              isDisaster: res.ticket ? res.ticket.startsWith('trerror_') : '',
              captcha: captchaInstance
            });
          }
        },
        {
          type: CAPTCHA_CONFIG.type,
          userLanguage: lang || CAPTCHA_CONFIG.userLanguage
        }
      );
      captchaInstance.show();
    } catch (err) {
      // 异常 → 容灾
      const disasterRes = generateDisasterTicket(1001, '初始化异常');
      disasterRes.captcha = captchaInstance;
      resolve(disasterRes);
    }
  });

  // 4. 核心：把实例直接挂在 promise 上
  // 这样无论 then/catch，外部都能拿到实例并销毁
  promise.captcha = captchaInstance;

  // 5. 快捷销毁方法
  promise.destroy = () => {
    if (promise.captcha) {
      try {
        promise.captcha.destroy();
      } catch (e) {}
      promise.captcha = null;
    }
  };
  return promise;
}

export { createCaptcha };
